"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.deleteUserSettings = exports.updateUserSettings = exports.getUserSettings = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _fetchwithauth = _interopRequireDefault(require("./fetchwithauth"));

var _httpmethods = _interopRequireDefault(require("./httpmethods"));

var baseUrl = "https://customizr.at.cimpress.io";

var getRoute = function getRoute(resourceId) {
  return "v1/resources/".concat(resourceId, "/settings");
};

var getResourceId = function getResourceId(contextId) {
  return encodeURIComponent("ucn:".concat(contextId));
};

var getUserSettings = /*#__PURE__*/function () {
  var _ref2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(_ref) {
    var accessToken, contextId, resourceId;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            accessToken = _ref.accessToken, contextId = _ref.contextId;
            resourceId = getResourceId(contextId);
            return _context.abrupt("return", (0, _fetchwithauth["default"])({
              baseUrl: baseUrl,
              route: getRoute(resourceId),
              accessToken: accessToken
            }));

          case 3:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function getUserSettings(_x) {
    return _ref2.apply(this, arguments);
  };
}();

exports.getUserSettings = getUserSettings;

var updateUserSettings = function updateUserSettings(_ref3) {
  var accessToken = _ref3.accessToken,
      contextId = _ref3.contextId,
      context = _ref3.context,
      timeToLive = _ref3.timeToLive;
  var resourceId = getResourceId(contextId);
  return (0, _fetchwithauth["default"])({
    baseUrl: baseUrl,
    route: getRoute(resourceId),
    method: _httpmethods["default"].PUT,
    accessToken: accessToken,
    body: context,
    additionalHeaders: {
      "X-Settings-TTL": timeToLive
    }
  });
};

exports.updateUserSettings = updateUserSettings;

var deleteUserSettings = function deleteUserSettings(_ref4) {
  var accessToken = _ref4.accessToken,
      contextId = _ref4.contextId;
  var resourceId = getResourceId(contextId);
  return (0, _fetchwithauth["default"])({
    baseUrl: baseUrl,
    route: getRoute(resourceId),
    accessToken: accessToken,
    method: _httpmethods["default"].DELETE
  });
};

exports.deleteUserSettings = deleteUserSettings;